import React from 'react'
import { Message, Button } from 'element-react'

const MessageSG = () => {
    const open = () => {
        Message({
            message: 'Congrats, this is a success message.',
            type: 'success',
            showClose: true,
            duration: 0,
            customClass: 'el-message--success',
            iconClass: 'el-message__icon el-icon-circle-check',
        })
    }

    const open2 = () => {
        Message({
            message: 'Warning, this is a warning message.',
            type: 'warning',
            showClose: true,
            duration: 0,
            customClass: 'el-message--warning',
            iconClass: 'el-message__icon el-icon-warning',
        })
    }

    const open3 = () => {
        Message({
            message: 'This is a message.',
            type: 'info',
            showClose: true,
            duration: 0,
            customClass: 'el-message--info',
            iconClass: 'el-message__icon el-icon-information',
        })
    }

    const open4 = () => {
        Message({
            message: 'Oops, this is a error message.',
            type: 'error',
            showClose: true,
            duration: 0,
            customClass: 'el-message--error',
            iconClass: 'el-message__icon el-icon-circle-cross',
        })
    }

    return (
        <div>
            <Button onClick={open} type="success">
                success
            </Button>
            <Button onClick={open2} type="warning">
                warning
            </Button>
            <Button onClick={open3} type="info">
                message
            </Button>
            <Button onClick={open4} type="danger">
                error
            </Button>
        </div>
    )
}

export default MessageSG
